@if (currentSelectedAssignment()) {
    <!-- TODO: there is a chance if the assignment is from assignment list, we don't have the needed topic data -->
    <st-assignment-full-screen
        [data]="currentSelectedAssignment()"
        [disabled]="currentSelectedAssignment()?.topicMetadata?.Path?.isWasteBinPath"
        [parentTopicMosActive]="parentTopicMosActive()"
        [sidecarMenu]="sidecarMenu()" />
    <div class="st-assignment-list-sidecar-pager">
        <button
            mat-icon-button
            class="st-assignment-list-sidecar-pager-button-first"
            (click)="navigate($event, NavigationDirection.FIRST)">
            <mat-icon>first_page</mat-icon>
        </button>
        <button
            mat-icon-button
            class="st-assignment-list-sidecar-pager-button-previous"
            (click)="navigate($event, NavigationDirection.PREVIOUS)">
            <mat-icon>navigate_before</mat-icon>
        </button>
        <span class="st-assignment-list-sidecar-pager-text">Assignment {{ indexInParentToShow() }} of {{ totalCount() }}</span>
        <button
            mat-icon-button
            class="st-assignment-list-sidecar-pager-button-next"
            (click)="navigate($event, NavigationDirection.NEXT)">
            <mat-icon>navigate_next</mat-icon>
        </button>
        <button
            mat-icon-button
            class="st-assignment-list-sidecar-pager-button-last"
            (click)="navigate($event, NavigationDirection.LAST)">
            <mat-icon>last_page</mat-icon>
        </button>
    </div>
} @else {
    <div class="st-assignment-list-sidecar-label">
        <span>{{ assignmentsLabel() }}</span>
        <st-item-layout-toggle
            [showLabel]="true"
            [isCondensed]="isAssignmentsCondensedLayout()"
            (layoutChange)="setAssignmentsCondensedLayout($event)" />
    </div>
    <div class="st-assignment-list-sidecar__grid">
        <mat-button-toggle-group
            class="st-assignment-list-sidecar-buttons-group"
            [value]="selectedListSearchType()"
            (change)="toggleSearchTab($event)">
            <mat-button-toggle
                class="st-assignment-list-sidecar-buttons-group__search"
                [value]="SearchType.SEARCH">
                {{ languageSettings().PSTWebCastSearchTabLabel }}
            </mat-button-toggle>
            <mat-button-toggle
                class="st-assignment-list-sidecar-buttons-group__views"
                [value]="SearchType.SAVED">
                {{ languageSettings().PSTWebSavedViewsTabLabel }}
            </mat-button-toggle>
        </mat-button-toggle-group>

        <div class="st-assignment-list-sidecar__grid__right">
            @if (savedViewDropdownVisible()) {
                <mat-form-field
                    class="st-assignment-list-sidecar__views-dropdown"
                    subscriptSizing="dynamic">
                    <mat-label>{{ languageSettings().PSTWebCastObjectsDropDownLabel }}</mat-label>
                    <mat-select
                        [value]="currentViewState()?.Guid"
                        [placeholder]="languageSettings().PSTWebSavedViewsLabel"
                        (selectionChange)="onViewStateGuidChanged($event)">
                        @for (item of selectSavedViewStates(); track item.Guid) {
                            <mat-option [value]="item.Guid">
                                {{ item.Title }}
                            </mat-option>
                        }
                    </mat-select>
                </mat-form-field>
            } @else {
                <div class="st-assignment-list-sidecar__search-bar">
                    <st-simple-search-box-autocomplete
                        st-click-stop-propagation
                        class="st-cast-objects-list__search-bar__search"
                        (searchExecute)="onSearchHandler($event)" />
                </div>
            }
        </div>
    </div>
    @if (selectAssignments()?.length === 0) {
        <div class="st-assignment-list-sidecar-text">
            {{ 'Sorry, there are no results matching your criteria' }}
        </div>
    } @else {
        <div class="st-assignment-list-sidecar-list-container">
            @if (isAssignmentsCondensedLayout()) {
                <st-condensed-list-header-labels
                    class="st-assignment-list-sidecar-condensed-header"
                    [cardViewType]="cardViewType()"
                    [variant]="ObjectTypes.ASSIGNMENT"
                    [showApprove]="showApproveColumn()" />
            }
            <cdk-virtual-scroll-viewport
                maxBufferPx="0"
                minBufferPx="0"
                class="st-assignment-list-sidecar-viewport"
                [itemSize]="itemSize()">
                <div
                    *cdkVirtualFor="let record of selectAssignments(); last as isLast; trackBy: trackByGuid; templateCacheSize: 0"
                    class="st-assignment-list-sidecar-viewport-assignment-item">
                    @if (isAssignmentsCondensedLayout()) {
                        <st-assignment-condensed
                            [data]="record"
                            [cardViewType]="cardViewType()"
                            [isReadOnly]="record?.topicMetadata?.Path?.isWasteBinPath"
                            (assignmentItemClicked)="onFullscreenHandler(record)" />
                    } @else {
                        <st-assignment-item
                            class="st-assignment-list-sidecar-viewport-assignment-item-type"
                            [data]="record"
                            [cardViewType]="cardViewType()"
                            [attr.small]="cardViewType() === CardViewType.SMALL"
                            [disabled]="record?.topicMetadata?.Path?.isWasteBinPath"
                            [inSidecarOpenedMode]="isSideCarMenuSelected()"
                            (assignmentOpenEmitter)="onFullscreenHandler(record)" />
                    }
                </div>
            </cdk-virtual-scroll-viewport>
        </div>
    }
}
